import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LeftTree from "./components/LeftTree.vue";
import DetailModel from './components/DetailModel.vue';
import { exportWorkstationLogin } from '@/api/api';
import { StatisticsServiceProxy,WorkStationEfficiencyServiceProxy } from "@/service-proxies/app-v2/mdc.service-proxies";
import dayjs from "dayjs";

const stsp = new StatisticsServiceProxy()
const wsesp = new WorkStationEfficiencyServiceProxy()

@Component({
  components: {
    LeftTree,
    DetailModel
  }
})
class Stationcomprehensive extends Vue {
  get columns(){
    return[
      {
        title: this.$t('page_station_comprehensive_workstation_name'),
        dataIndex:'workStationName',
        key: 'workStationName',
        width: 130
      },
      {
        title: this.$t('page_station_comprehensive_employee_name'),
        dataIndex:'employeeName',
        key: 'employeeName',
        width: 130,
        customRender: (row, record) => {
          return (
            <a onClick={e => {e.stopPropagation();this.handleShowDetail(record)}}> { row } </a>
          )
        },
      },
      {
        title: this.$t('page_station_comprehensive_date'),
        dataIndex:'date',
        key: 'date',
        width: 230
      },
      {
        title: this.$t('page_station_comprehensive_working_hours') + "(h)",
        dataIndex:'workingHours',
        key: 'workingHours',
        width: 230,
        customRender: (row) => {
          return (
            <div> { row } </div>
          )
        },
      },
      {
        title: this.$t('page_station_comprehensive_poor_yield'),
        dataIndex:'poorYield',
        key: 'poorYield',
        width: 230
      },
      {
        title: this.$t('page_station_comprehensive_report_num'),
        dataIndex:'reportNum',
        key: 'reportNum',
        width: 230
      },
      {
        title: this.$t('page_station_comprehensive_running_time') + "(h)",
        dataIndex:'runningTime',
        key: 'runningTime',
        width: 230,
        customRender: (row) => {
          return (
            <div> { row } </div>
          )
        },
      },
      {
        title: this.$t('page_station_comprehensive_avg_yield') + "(h)",
        dataIndex:'avgYield',
        key: 'avgYield',
        width: 230,
        customRender: (row) => {
          return (
            <div> { row } </div>
          )
        },
      },{
        title: this.$t('page_station_comprehensive_processing_efficiency'),
        dataIndex:'efficiency',
        key: 'efficiency',
        width: 200,
        customRender: (row) => {
          return (
            <div> { row } </div>
          )
        },
      }
    ]
  };
  operationData = [];
  loading = false;
  searchValue:any = {};
  defaultActiveKey = 0;
  tabsdData = []
  detail = {
    current: 1,
    size: 10,
    visible: false,
    data: [],
    total: 0,
    filter: {}
  }
  startDate = null
  endDate = null

  render() {
    return (
      <a-layout style="height: 100%">
        <a-layout-sider
          width="360"
          style="background: #fff; min-width:360px; overflow:auto;"
          class="no-fix-sider"
        >
          <left-tree
            init={["statistical", "shift", "time", "Tree.vue"]}
            onSearch={(value) => this.search(value)}
            onOutPut={() => this.outPut()}
            queryKey="station-comprehensive"
          ></left-tree>
        </a-layout-sider>
        <div v-resize={"x"}></div>
        <a-layout-content style={{ height: "100%" }}>
          {this.renderBody()}
        </a-layout-content>
      </a-layout>
    );
  }

  handleShowDetail(record) {
    const data = {
      employeeCode: record.employeeCode,
      employeeId: record.employeeId,
      endTime: this.endDate,
      startTime: this.startDate,
      workstationId: record.workstationId
    } as any
    this.detail.filter = data
    this.detail.data = []
    this.getDetailList()

  }

  getDetailList(){
    const data:any = this.detail.filter
    wsesp.workStationLoginDetailPage(this.detail.current,this.detail.size,data).then(res =>{
      if(res.total) {
        this.detail.data = res.records
        this.detail.total = Number(res.total)
        this.detail.visible = true
      }
    })
  }

  outPut() {}

  search(value) {
    console.log(value)
    delete value.productivityType
    this.searchValue = {...value}
    stsp.splitFilter(value).then(res =>{
      this.tabsdData = (res.items).reverse()
      this.defaultActiveKey = 0
      if(res.items){
        this.getTableList(this.tabsdData[0])
      }
    })
  }

  getTableList(value){
    this.startDate = dayjs(value.date).startOf(value.statisticalMethod.toLowerCase()).format('YYYY-MM-DD 00:00:00')
    this.endDate = dayjs(value.date).endOf(value.statisticalMethod.toLowerCase()).format('YYYY-MM-DD 23:59:59')
    const data = {
      date: value.date,
      startDate: this.startDate,
      month: value.month,
      endDate: this.endDate,
      statisticalMethod: value.statisticalMethod,
      week: value.week,
      workStationList: value.workStationList,
      year: value.year
    } as any
    this.operationData = []
    wsesp.searchData(data).then(res =>{

      let arr = [];

      for(var i=0; i<data.workStationList.length; i++) {
        for(var j=0; j<res.length; j++) {
          if(data.workStationList[i].key == res[j].workstationId) {
            arr.push(res[j])
          }
        }
      }

      // this.operationData = res
      this.operationData = arr;
    }).catch(err => {

    })
  }

  export(){
    const dataList = []
    const weekList = []
    const monthList = []
    const yearList = []
    this.tabsdData.forEach(res =>{
      if(dataList.indexOf(res.date) === -1){
        dataList.push(res.date)
      }
      if(weekList.indexOf(res.week) === -1){
        weekList.push(res.week)
      }
      if(monthList.indexOf(res.month) === -1){
        monthList.push(res.month)
      }
      if(yearList.indexOf(res.year) === -1){
        yearList.push(res.year)
      }
    })
    const value = {
      date: dataList.reverse(),
      month: monthList.reverse(),
      statisticalMethod: this.searchValue.statisticalMethod,
      week: weekList.reverse(),
      workStationList: this.searchValue.workStationList,
      year: yearList.length > 0 ? (yearList.reverse())[0] : 0,
      endTime: this.endDate,
      startTime: this.startDate,
    }
    exportWorkstationLogin(value).then (res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_station_comprehensive_statistics_report')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  renderBody() {
    return (
      <blank-view>
        <div slot="action" style="display: flex; justify-content: space-between;">
          <a-button type="primary" onClick={() => this.export()}>{this.$t('page_product_export')}</a-button>
        </div>
        <div style="height: calc( 100% - 60px )">
          <a-tabs
            active-key={this.defaultActiveKey}
            tab-position={'top'}
            onPrevClick={this.callback}
            onNnextClick={this.callback}
            tabBarGutter={4}
            onChange={value => this.changeTabs(value)}
          >
            {this.tabsdData.length > 0 ? this.tabsdData.map((res,index) =>{return (<a-tab-pane key={index} tab={res.title}></a-tab-pane>)}) : null}
          </a-tabs>
          {this.loading ? (
            <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
              <a-spin />
            </div>
          ) : (
            this.operationData.length > 0 ? this.renderTable() : this.renderEmpty()
            )}
        </div>
        <detail-model filters={this.detail} onClose={() => this.reloadDetail()} onPageIndexchange={(current) => this.changeDetail(current)}></detail-model>
      </blank-view>
    );
  }

  reloadDetail(){
    this.detail.current = 1
    this.detail.data = []
    this.detail.size = 10
    this.detail.visible = false
    this.detail.total = 0
  }

  changeDetail(current){
    this.detail.current = current
    this.getDetailList()
  }

  callback(){

  }

  renderEmpty(){
    return (
      <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"><wm-empty text={this.$t('page_wm_empty')} /></div>
    )
  }

  changeTabs(value){
    this.tabsdData.forEach((res,index) =>{
      if (index === value){
        this.defaultActiveKey = value
        this.getTableList(res)
      }
    })
  }

  renderTable() {
    return (
      <ml-table
        size="small"
        columns={this.columns}
        defaultExpandAllRows={true}
        dataSource={this.operationData}
        scroll={{ x: 1410, y: 750 }}
        isAutoWidth={true}
      ></ml-table>
    );
  }

}

export default Stationcomprehensive;
